/* ══════════════════════════════════════════════════════════
   ELIZ BUTIK — Ödeme Seçenekleri JS (Tema Asset)
   Shopify page'inde <script> strip edildiği için JS burada tutulur.
   Ürün template'inde bir Custom Liquid bloğu bu asset'i çağırır:
     <script src="{{ 'eliz-payment.js' | asset_url }}" defer></script>
   Sayfa DOM'unda .eliz-pay-page bulursa initialize eder — yoksa sessizce çıkar.
   ══════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  function init(root){
    if (!root || root.dataset.elizPayInit === '1') return;
    root.dataset.elizPayInit = '1';

    var paytrToken   = root.dataset.paytrToken   || '';
    var merchantId   = root.dataset.paytrMerchant || '';
    var havaleEl     = root.querySelector('[data-eliz-havale-price]');
    var paytrTablo   = root.querySelector('[data-eliz-paytr-tablo]');
    var rows         = root.querySelectorAll('.eliz-bank-info__row');

    var product = null;
    var currentVariantId = null;
    var paytrLoaded = false;

    /* Sadece ürün sayfasında çalışır */
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!m) return;
    var handle = m[1];

    function formatTL(cents){
      return (cents/100).toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
    }

    function pickVariant(){
      if (!product) return null;
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form){
        var sel = form.querySelector('select[name="id"]');
        if (sel && sel.value) return product.variants.find(function(v){ return String(v.id) === String(sel.value); });
        var r = form.querySelector('input[name="id"][type="radio"]:checked');
        if (r) return product.variants.find(function(v){ return String(v.id) === String(r.value); });
        var h = form.querySelector('input[name="id"][type="hidden"]');
        if (h) return product.variants.find(function(v){ return String(v.id) === String(h.value); });
      }
      return product.variants.find(function(v){ return v.available; }) || product.variants[0];
    }

    function updateHavale(){
      if (!havaleEl) return;
      var v = pickVariant();
      if (!v) return;
      havaleEl.textContent = formatTL(v.price);
      currentVariantId = v.id;
    }

    function loadPaytrTable(force){
      if (!paytrTablo || !paytrToken || !merchantId) return;
      var v = pickVariant();
      if (!v) return;
      if (!force && paytrLoaded && String(currentVariantId) === String(v.id)) return;
      currentVariantId = v.id;
      paytrLoaded = true;
      var amount = (v.price / 100).toFixed(2);
      /* PayTR script'i target olarak `paytr_taksit_tablosu` ID'sini bekler */
      if (!paytrTablo.id) paytrTablo.id = 'paytr_taksit_tablosu';
      paytrTablo.innerHTML = "";
      var s = document.createElement("script");
      s.src = "https://www.paytr.com/odeme/taksit-tablosu/v2"
            + "?token="       + encodeURIComponent(paytrToken)
            + "&merchant_id=" + encodeURIComponent(merchantId)
            + "&amount="      + encodeURIComponent(amount)
            + "&taksit=0&tumu=0";
      s.onload = function(){
        try {
          var wrappers = Array.prototype.slice.call(paytrTablo.querySelectorAll(".taksit-tablosu-wrapper"));
          if (!wrappers.length) return;
          var keep = wrappers[0];
          wrappers.forEach(function(w){ if (w !== keep) w.remove(); });
          keep.querySelectorAll(".taksit-logo, .taksit-logo img, img").forEach(function(el){ el.remove(); });
          var header = document.createElement("div");
          header.className = "eliz-pay-card__head";
          header.innerHTML =
            '<span class="eliz-pay-card__dot"></span>' +
            '<span class="eliz-pay-card__title">Kredi Kartı</span>' +
            '<span class="eliz-pay-card__dot"></span>';
          keep.prepend(header);
        } catch(e){}
      };
      paytrTablo.appendChild(s);
    }

    /* Product datasını AJAX ile çek */
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !p.variants) return;
        product = p;
        updateHavale();
        maybeLoadPaytr();
      })
      .catch(function(){});

    /* Collapsible details toggle → PayTR yükle */
    var parentDetails = root.closest('details');
    function maybeLoadPaytr(){
      if (!parentDetails || parentDetails.open) loadPaytrTable(false);
    }
    if (parentDetails) {
      parentDetails.addEventListener('toggle', function(){
        if (parentDetails.open) loadPaytrTable(false);
      });
    } else {
      loadPaytrTable(false);
    }

    /* Variant değişikliği */
    function refresh(){
      updateHavale();
      if (parentDetails && parentDetails.open) loadPaytrTable(true);
      else if (!parentDetails) loadPaytrTable(true);
    }
    document.addEventListener('change', function(e){
      if (e.target && e.target.name === 'id') refresh();
    });
    document.addEventListener('variant:change', refresh);

    /* Banka bilgi tıkla-kopyala */
    function fallbackCopy(text){
      try {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        ta.style.pointerEvents = "none";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        return true;
      } catch(e){ return false; }
    }
    function doCopy(text){
      if (navigator.clipboard && window.isSecureContext){
        return navigator.clipboard.writeText(text).catch(function(){ return fallbackCopy(text); });
      }
      return Promise.resolve(fallbackCopy(text));
    }
    rows.forEach(function(row){
      var timer = null;
      row.addEventListener("click", function(e){
        e.preventDefault();
        var val = row.getAttribute("data-copy");
        if (!val) return;
        doCopy(val).then(function(){
          row.classList.add("is-copied");
          if (timer) clearTimeout(timer);
          timer = setTimeout(function(){ row.classList.remove("is-copied"); }, 1600);
        });
      });
    });
  }

  function boot(){
    var roots = document.querySelectorAll('.eliz-pay-page[data-eliz-pay]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
